import { useEndCampaignMutation } from '@/entities/campaign/mutation/use-end-campaign-mutation';
import { requestConfirm } from '@/shared/utils/request-confirm';

export const useEndCampaignRequest = () => {
  const endCampaignMutation = useEndCampaignMutation();

  const onEndCampaign = (campaignId: string, campaignName: string) => {
    void requestConfirm({
      title: 'End campaign?',
      description: (
        <>
          Are you sure you want to end "{campaignName}"?
          <br />
          The campaign will end tomorrow.
        </>
      ),
      confirmButton: {
        children: 'End campaign',
        variant: 'destructive',
      },
      onConfirm: async () => {
        await endCampaignMutation.mutateAsync({
          campaignId,
        });
      },
    });
  };

  return onEndCampaign;
};
